export const GLH_MENU_OPTIONS = {};
